import notification from 'ant-design-vue/es/notification'
import { i18nRender } from '@/locales'
import CryptoJS from 'crypto-js'
import { loadFromLocal } from '@/utils/storage'

/* eslint-disable no-undef */
export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

export function isFirefox () {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  return userAgent.indexOf('Firefox') > -1
}

// 弹窗信息 修改图标
export function notificationIconRender (h, type) {
  switch (type) {
    case 'success':
      return h(
        'span', {
          class: 'gb-icon-chenggong',
          style: {
            fontSize: '26px',
            color: '#52c41a'
          }
        }
      )
    case 'warning':
      return h(
        'span', {
          class: 'gb-icon-tishi',
          style: {
            fontSize: '26px',
            color: '#faad14'
          }
        }
      )
    default:
      return h(
        'span', {
          class: 'gb-icon-tishi',
          style: {
            fontSize: '26px',
            color: '#5785FB'
          }
        }
      )
  }
}

// 警告弹窗
export function openNotificationWithIcon (text = false, type = 'warning') {
  if (typeof text === 'boolean' && text === false) {
    notification.destroy()
    return
  }
  setTimeout(() => {
    notification.warning({
      message: i18nRender('notification-modal.title.prompt'),
      description: text,
      icon: (h) => notificationIconRender(h, type)
    })
  }, 16)
}

var timer = null
export function debounce (fn, delay) {
  return (function () {
    if (timer !== null) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn, delay)
  })()
}

/**
 * @description: 下载文件
 * @param {blob=*} data blob元数据
 * @param {string=*} name 文件名称
 * @param {string} type 文件类型
 */
export function downloadFn (data, name, type) {
  if ('download' in document.createElement('a')) { // 非IE下载
    let merge = data
    if (data instanceof Blob && type) {
      merge = new Blob([data], { type })
    }
    const elink = document.createElement('a')
    elink.download = isFirefox() ? name.substring(0, name.lastIndexOf('.')) : name
    elink.style.display = 'none'
    elink.href = window.URL.createObjectURL(merge)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL对象
    document.body.removeChild(elink)
  } else { // IE10+下载
    navigator.msSaveBlob(data, name)
  }
}

// AES加密
export function encrypt (word, keyStr = 'rhnmdud7trabrta1') {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let key = CryptoJS.enc.Utf8.parse(keyStr)
  let iv = CryptoJS.enc.Utf8.parse('1131100000022322')
  let encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv })
  return encrypted.toString()
}

// AES解密
export function decrypt (word, keyStr = 'rhnmdud7trabrta1') {
  let key = CryptoJS.enc.Utf8.parse(keyStr)
  let iv = CryptoJS.enc.Utf8.parse('1131100000022322')
  let decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

// validateForm
export function validateForm (formName) {
  return new Promise((resolve, reject) => {
    this.$refs[formName].validate((flag, obj) => {
      if (flag) {
        resolve()
      } else {
        const _obj = { validateError: true, errorDOTS: obj }
        reject(_obj)
      }
    })
  })
}

/**
 * @description: 集成事件委托和销毁 （EventTarget.addEventListener）
 * @param { string } type 触发方式
 * @param { function=* } listener 事件通知 (函数回调或者一个实现了EventListener接口的对象)
 * @param { object } options 指定有关listener属性的可选参数对象
 * @param { object } config 事件委托指定对象及销毁监听对象
 */
export function eventListener (type = 'click', listener, options, config) {
  const mergeConfig = {
    element: window,
    hook: 'deactivated',
    ...config
  }
  const mergeOptions = typeof options === 'boolean' ? options : {
    capture: false, // 表示在事件冒泡阶段调用；当该值为true时，表示在事件捕获阶段调用
    once: false, // 为true，表示回调函数最多只调用一次
    passive: false, // 为true时，表示listener永远不会调用preventDefault()阻止默认行为的方法
    ...options
  }
  const that = mergeConfig.target || this
  mergeConfig.element.addEventListener(type, listener, mergeOptions)
  that.$once(`hook:${mergeConfig.hook}`, function () {
    mergeConfig.element.removeEventListener(type, listener, mergeOptions)
  })
}

/**
 * 视频地址首帧转为base64 （视频封面）
 * @param {*} url 视频地址
 * @param {*} options 配置项
 * @returns {promise} (base64)
 */
export function getVideoBase64 (url, options) {
  const { scale, width, sx, sy } = {
    scale: 500,
    width: 1000,
    sy: 0,
    sx: 0,
    ...options
  }
  return new Promise(function (resolve, reject) {
    let dataURL = ''
    let video = document.createElement('video')
    video.setAttribute('crossOrigin', 'anonymous')// 处理跨域
    video.setAttribute('src', url)
    video.setAttribute('preload', 'auto')
    video.addEventListener('loadeddata', function () {
      let canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = width * 0.5625
      canvas.getContext('2d').drawImage(video, (video.videoWidth * 0.5 - scale * 0.5) + sx, (video.videoHeight * 0.5 - scale * 0.5 * 0.5625) + sy, scale, scale * 0.5625, 0, 0, width, width * 0.5625)
      dataURL = canvas.toDataURL('image/png') // 转换为base64
      video = null
      resolve(dataURL)
    })
  })
}

export function getDetaultList () {
  return [
    {
      key: 'exportCenterDefaultKey',
      ignore: true,
      menuName: {
        zh_CN: '导出中心',
        en_US: 'Export Center'
      },
      getPath: (serviceId = '', systemCode = '') => `/entry/${serviceId}/${systemCode}/universal_system#/download-center`
    }
  ]
}

// 获取公司代码
export function getCompanyCode() {
  const companyCode = process.env.NODE_ENV === 'development' ? 'companyCode' : 'company'

  return {
    [companyCode]:
      process.env.NODE_ENV === 'development'
        ? 'kaifa'
        : loadFromLocal('pro__uesr_info')?.value?.subjectCodeEncrypt
  }
}
